<template>
  <Teleport to="body">
    <div
      v-if="show" 
      :class="[
        'tw-fixed tw-bottom-0 tw-left-0 tw-w-full',
        'apDesktop:tw-px-[64px] tw-px-6 apDesktop:tw-py-6 tw-py-8 tw-bg-white',
        'tw-flex tw-justify-between tw-items-center tw-flex-col apDesktop:tw-flex-row',
        'tw-z-[999999] tw-gap-[64px] apDesktop:tw-gap-0',
        'tw-rounded-tl-[20px] tw-rounded-tr-[20px]',
        'apDesktop:!tw-rounded-tl-[0px] apDesktop:!tw-rounded-tr-[0px]',
      ]"
    >
      <section class="tw-pr-4">
        <div class="tw-text-cookie-consent-title">
          Cookie consent
        </div>
        <div class="tw-text-body-md-mobile tablet:tw-text-body-md-desktop">
          This website uses cookies to enhance your browsing experience and provide personalised content. <a @click="onClickShowCookiePolicy">Learn more</a>
        </div>
      </section>
      <section class="tw-flex tw-gap-4 tw-flex-col-reverse apDesktop:tw-flex-row tw-w-full apDesktop:tw-w-auto">
        <button
          :class="[
            'tw-text-body-md-mobile tablet:tw-text-body-md-desktop tw-text-ap-nero',
            'tw-px-6 tw-py-4 tw-rounded-xl',
            'tw-outline tw-outline-ap-gainsboro tw-outline-offset-[-2px] tw-outline-1',
            'tw-cursor-pointer tw-text-nowrap'
          ]"
          @click="onClickManageMyPreferences"
        >Manage my preferences</button>
        <button
          :class="[
            'tw-text-body-md-mobile tablet:tw-text-body-md-desktop',
            'tw-px-6 tw-py-4 tw-rounded-xl',
            'tw-bg-ap-dodger-blue tw-text-white',
            'tw-cursor-pointer tw-text-nowrap'
          ]"
          @click="onClickAcceptAll"
        >Accept all</button>
      </section>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ref } from 'vue';


defineProps({
  show: {
    type: Boolean,
    default: false
  },
});

const emit = defineEmits(['update:show', 'clickManageMyPreferences', 'showCookiePolicy']);

function onClickManageMyPreferences() {
  emit('update:show', false);
  emit('clickManageMyPreferences');
}

function onClickAcceptAll() {
  savePreferencesToLocalStorage();
  emit('update:show', false);
}

function onClickShowCookiePolicy() {
  emit('showCookiePolicy');
  emit('update:show', false);
}

interface CookieSetting {
  key: string,
  title: string,
  subtitle: string,
  value: boolean,
  isLocked: boolean
};

const settings = ref<CookieSetting[]>([
  {
    key: 'essential',
    title: 'Essential',
    subtitle: 'These cookies are necessary to provide you with services available through our website.',
    value: true,
    isLocked: true
  },
  {
    key: 'performance',
    title: 'Performance',
    subtitle: 'We use cookies to improve your experience. By using our site, you agree to our use of cookies.',
    value: true,
    isLocked: false
  },
  {
    key: 'analytics',
    title: 'Analytics',
    subtitle: 'These cookies analyse website usage, track marketing effectiveness, and customise our website for you.',
    value: true,
    isLocked: false
  },
  {
    key: 'social_networking',
    title: 'Social networking',
    subtitle: 'These cookies allow you to share pages and content from our website to social networks.',
    value: true,
    isLocked: false
  },
]);

const savePreferencesToLocalStorage = () => {
  const preferences = settings.value.reduce((acc, setting) => {
    acc[setting.key] = setting.value;
    return acc;
  }, {} as Record<string, boolean>);

  localStorage.setItem('cookiePreferences', JSON.stringify(preferences));
};

</script>

<style scoped>
</style>